<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
			width="90%"
			:maxWidth="800"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center justify-start">
							<v-icon color="warning" class="mr-2">mdi-account-file-outline</v-icon>
							<p class="mb-0 font-weight-bold text-primary body-1">Ingresar Nueva Solicitud</p>
						</div>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									dark
									small
									color="#959595"
									@click="$store.commit('userrequests/setNewRequestModal', false)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon dark>mdi-close</v-icon>
								</v-btn>
							</template>
							<span>Cerrar</span>
						</v-tooltip>
					</div>
				</v-card-title>
				<v-card-text class="pa-0">
          <div class="pb-4 px-8">
						<div class="mt-6">
							<div v-if="modalInfo?.project_line_id">
								<p class="mb-3">Estás solicitando un <b>{{ requestTypeText }}</b> para la Línea de Proyecto: <b>{{ this.modalInfo.project_name }}</b></p>
							</div>
							<div v-else>
								<div class="mb-2">
									<p class="mb-0 font-weight-bold">Por favor selecciona el proyecto para el que quieres hacer la solicitud:</p>
								</div>
								<v-autocomplete
									v-model="request.project_line_id"
									:items="mappedUserProjectLines"
									:menu-props="{ bottom: true, offsetY: true }"
									:loading="$store.state.general.loadingUserProjectLines"
									item-text="name"
									item-value="project_line_id"
									label="Busca la línea de proyectos"
									class="flex-grow-0 mb-0"
									autocomplete="off"
									outlined
									dense
									required
									hide-details
									no-data-text="Busca la línea de proyectos"
									:rules="requiredRule"
									:filter="customFilter"
									@change="onChangeProjectLine"
								>
									<template v-slot:item="data">
										<v-list-item-content>
											<v-list-item-title>
												<div class="d-flex">
													<p class="mb-0" style="width: 200px;" v-if="data.item.project_line_id == -1">
														<span class="font-weight-bold" style="font-size: 15px;">{{data.item.name}}</span>
													</p>
													<p class="mb-0" style="width: 200px" v-else>
														<span class="font-weight-bold">{{data.item.name}}</span><br/>
														<span class="light-blue-text">{{data.item.address}}</span>
													</p>
												</div>
											</v-list-item-title>
										</v-list-item-content>
									</template>
									<template v-slot:selection="data">
										<v-chip
											v-bind="data.attrs"
											:input-value="data.selected"
											close
											@click="data.select"
											@click:close="request.project_line_id = null"
											small
										>
											{{ data.item.name }}
										</v-chip>
									</template>
								</v-autocomplete>
								<p style="font-size: 10px;">Escribe al menos 3 letras para iniciar una búsqueda. Busca por nombre cliente, dirección o tipo de proyecto.</p>
							</div>
							<div>
								<!-- <v-row>
									<v-col cols="12">
										<ProjectTypeSelectorMenuSelect
												:fullView="true"
												:denseInput="false"
												:projectType="parentRequestType"
												:onClick="(project_type) => { changeProjectType(project_type) }"/>
									</v-col>
								</v-row> -->
								<v-row v-if="request.project_line_id == -1">
									<v-col cols="12">
										<v-autocomplete
											v-model="request.address"
											:items="[...items, ...[request.address]]"
											name="address"
											:search-input.sync="search"
											prepend-inner-icon="mdi-map-marker"
											label="Dirección"
											placeholder="Dirección"
											autocomplete="off"
											outlined
											dense
											hide-details
											:filter="d => d"
											color="secondary"
											item-color="secondary"
											return-object
											@change="change"
										></v-autocomplete>
									</v-col>
									<v-col cols="12" md="6">
										<v-select
											v-model="request.state_id"
											:items="$store.state.general.states"
											:loading="$store.state.general.loadingStates"
											:menu-props="{ top: true, offsetY: true }"
											item-text="name"
											item-value="id"
											label="Seleccione Región"
											outlined
											dense
											required
											:rules="requiredRule"
											@change="onChangeState"
										></v-select>
									</v-col>
									<v-col cols="12" md="6">
										<v-select
											v-model="request.district_id"
											:items="$store.state.general.cities"
											:loading="$store.state.general.loadingCities"
											item-text="name"
											item-value="id"
											label="Seleccione Comuna"
											outlined
											dense
											required
											:disabled="!request.state_id"
											:rules="requiredRule"
										></v-select>
									</v-col>
								</v-row>
							</div>
							<div>
								<p class="mb-0 caption">Por favor detalla tu solicitud, incluye la mayor cantidad de información posible para que el encargado la evalúe.</p>
								<v-textarea
									v-model="request.description"
									label="Detalles de la Solicitud"
									color="#524D4D"
									outlined
									rows="3"
									class="mt-2 w-100"
									required
									:rules="requiredRule"
								></v-textarea>
							</div>

							<div class="d-flex flex-row align-center justify-end mt-2">
								<v-btn
									depressed
									dark
									outlined
									color="#959595"
									class="mr-3"
									@click="$store.commit('userrequests/setNewRequestModal', false)"
								>
									<v-icon dark>mdi-close</v-icon>
									<p class="ml-2 mb-0">Cancelar</p>
								</v-btn>
								<v-btn
									depressed
									dark
									color="#959595"
									@click="confirmUserRequest"
									:loading="loadingCreation"
								>
									<v-icon dark>mdi-check</v-icon>
									<p class="ml-2 mb-0">Confirmar</p>
								</v-btn>
							</div>
						</div>
          </div>
        </v-card-text>
      </v-card>
    </modal>
		<GeneralConfirmationModal :modalData="confirmationModal" :closeModal="modalConfirmation"/>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import {createUserRequest} from '@/helpers/api/userrequests'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import GeneralConfirmationModal from '@/components/Modals/General/GeneralConfirmationModal'
// import ProjectTypeSelectorMenuSelect from '@/components/Helpers/Components/ProjectTypeSelectorMenuSelect'

export default {
  name: 'NewUserRequest',
	components: {GeneralConfirmationModal},
  data: () => ({
		indexModal: + new Date(),
		parentRequestType: null,
		selectedItem: null,
		confirmationModal: null,
		loadingCreation: false,
		autocompleteService: null,
		items: [],
		search: '',
		request: {
			project_line_id: null,
			request_type: 1,
			description: '',
			address: null,
			project_type_id: null,
			district_id: null,
			state_id: null,
			project_name: null,
			coordinates: null
		},
		requestTypes: [
			{ id: 1, name: 'Solicitud de Informe' },
			{ id: 2, name: 'Solicitud de Presupuesto' },
			{ id: 3, name: 'Solicitud de Contrato' },
			{ id: 4, name: 'Solicitud de Anexo de Contrato' },
		],
    requiredRule: [
      v => !!v || 'Campo requerido'
    ]
  }),
  computed: {
		google: gmapApi,
		requestTypeText(){
			if(this.request.request_type == 1){
				return 'Informe'
			}
			else if(this.request.request_type == 2){
				return 'Presupuesto'
			}
			else if(this.request.request_type == 3){
				return 'Contrato'
			}
			else if(this.request.request_type == 4){
				return 'Anexo de Contrato'
			}
			return ''
		},
		projectNameFromType() {
			let typeName = ''
			let districtName = ''
			// if (this.request?.project_type_id && this.parentRequestType) {
			// 	const project_type = this.parentRequestType?.sub_types.find(
			// 		(type) => type.id == this.request.project_type_id
			// 	)
			// 	if (project_type) {
			// 		typeName = project_type.name
			// 	}
			// }
			if (this.parentRequestType) {
				return this.parentRequestType.name
			}
			if (this.request?.district_id && this.$store.state.general?.cities) {
				const district = this.$store.state.general.cities.find(
					(d) => d.id == this.request.district_id
				)
				if (district) {
					districtName = district.name
				}
			}
			if (typeName && districtName) {
				return `${typeName} - ${districtName}`
			} else {
				return typeName || districtName || ''
			}
		},
		filteredCompaniesProjectTypes(){
			let allSubTypes = this.$store.state.companies.companiesProjectTypes.flatMap(item => item.sub_types || [])
			// return allSubTypes
			// if(this.request.project_line_id == -1){
			// 	allSubTypes = this.$store.state.companies.companiesProjectTypes.flatMap(item => item.sub_types || [])
			// 	return allSubTypes
			// }
			if(this.request.project_line_id != -1 && this.selectedProjectLine){
				const filteredAllSubTypes = this.$store.state.companies.companiesProjectTypes
																.filter((item) => {
																	return this.selectedProjectLine.project_type_id == item.id
																})
																.flatMap(item => item.sub_types || [])
				if(filteredAllSubTypes && filteredAllSubTypes.length){
					allSubTypes = filteredAllSubTypes
				}
			}
			return allSubTypes
			// return this.$store.state.companies.companiesProjectTypes.filter((item) => {
			// 	return item.show_in_client && item.sub_types.length > 0
			// })
		},
		selectedProjectLine() {
			return this.mappedUserProjectLines.find(
				pl => pl.project_line_id === this.request.project_line_id
			) || null
		},
		mappedUserProjectLines(){
			const pl = this.$store.state.general.userProjectLines.map((project_line) => {
				const project_info = this.getProjectType(project_line.associations).morphable
				return {
					project_line_id: project_line.id,
					project_type_id: project_info.info?.project_type_id,
					address: project_info.info?.address?.address ?? '',
					district: project_info.info?.address?.district?.name ?? '',
					name: project_info?.name || project_info?.info?.project_detail || '',
				}
			})
			pl.unshift({
				project_line_id: -1,
				address: '',
				district: '',
				name: 'Nuevo Proyecto',
			})
			return pl
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		queryRoute(){
			return this.$route
		},
		modalInfo(){
			return this.$store.state.userrequests.newRequestModalInfo
		}
	},
	watch: {
		queryRoute(){
			this.$store.commit('reports/setConfirmNewReportModal', false)
		},
    search(newSearch) {
      if (newSearch) {
        this.googleSearch(newSearch);
      } else {
        this.items = [];
      }
    }
	},
  mounted(){
		this.$modal.show('custom_drag_modal')
		this.$store.commit('general/addOpenModalOrders', this.indexModal)
		this.reloadInfo()
		this.$nextTick(() => {
			this.$gmapApiPromiseLazy().then(() => {
				this.autocompleteService = new this.google.maps.places.AutocompleteService()
			})
		})
		if(this.modalInfo){
			this.request = {
				...this.request,
				...{
					project_line_id: this.modalInfo.project_line_id,
					request_type: this.modalInfo.request_type,
				}
			}
		}
    eventBus.$on('reloadInformation', this.reloadInfo)
  },
	beforeDestroy(){
		eventBus.$off('reloadInformation', this.reloadInfo)
	},
  methods: {
		closeModal(){
			this.$store.commit('userrequests/setNewRequestModal', false)
		},
		reloadInfo(){
			this.$store.dispatch('general/getUserProjectLines')
			this.$store.dispatch('companies/getCompanyProjectTypes')
		},
		changeProjectType(project_type){
			console.log('changeProjectType', project_type)
			this.parentRequestType = project_type
		},
		onChangeProjectLine(){
			this.request = {
				...this.request,
				...{
					project_type_id: null,
					address: null,
					district_id: null,
					state_id: null,
					project_name: null,
					coordinates: null
				}
			}
		},
    googleSearch(query) {
      const options = {
        input: query,
				componentRestrictions: { country: 'CL' }
      };
      this.autocompleteService.getPlacePredictions(options, (predictions, status) => {
        if (status === this.google.maps.places.PlacesServiceStatus.OK) {
          this.items = predictions.map(prediction => ({
            text: prediction.description,
            value: prediction 
          }));
        } else {
          console.error('Error fetching predictions: ', status);
          this.items = [];
        }
      });
    },
		async getPlaceDetails(placeId) {
			if (typeof this.google !== 'undefined' && this.google.maps) {
				const service = new this.google.maps.places.PlacesService(document.createElement('div'));
				
				service.getDetails({ placeId }, (place, status) => {
					if (status === this.google.maps.places.PlacesServiceStatus.OK) {
						const { geometry } = place;
						this.request.coordinates = {
							lat: geometry.location.lat(),
							lng: geometry.location.lng()
						}
					}
				});
			} else {
				console.error('Google Maps API no está cargada');
			}
		},
    change(value) {
			this.getPlaceDetails(value.value.place_id)
      this.request.address = value.text;
    },
		onChangeState(state){
			this.$store.dispatch('general/getCities', state)
		},
		customFilter(item, queryText) {
			const name = item.name?.toLowerCase() || '';
			const address = item.address?.toLowerCase() || '';
			const query = queryText.toLowerCase();

			return name.includes(query) || address.includes(query);
		},
		getProjectType(items){
			const hierarchy = {
				'App\\Models\\BotConversation': 1,
				'App\\Models\\PreProject': 2,
				'App\\Models\\Project': 3
			};
			const mostRelevant = items.reduce((highest, current) => {
				const currentLevel = hierarchy[current.morphable_type] || 0;
				const highestLevel = highest ? hierarchy[highest.morphable_type] || 0 : 0;

				return currentLevel > highestLevel ? current : highest;
			}, null);
			return mostRelevant;
		},
		modalConfirmation(confirm = false){
			this.confirmationModal = null
			if(confirm){
				this.confirmReportCreation()
			}
		},
		async confirmUserRequest() {
			if (!this.request.description?.trim()) {
				const messageData = {
					message: 'Por favor ingresa los detalles de tu solicitud.',
					title: 'Información incompleta',
					type: 'warning',
					icon: 'mdi-alert-circle',
					color: '#F1C40F',
				}
				this.$store.dispatch('general/addMessage', messageData)
				return
			}
			this.loadingCreation = true
			let data = {
				...this.request,
			}
			data.project_name = this.projectNameFromType
			const report = await createUserRequest(data)
			this.loadingCreation = false
			if(report.code == 200){
				this.$store.commit('userrequests/setNewRequestModal', false)
				const messageData = {
					message: 'Se ha enviado la solicitud correctamente. Se ha notificado al encargado para que evalúe tu solicitud.',
					title: 'Solicitud enviada',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.$store.dispatch('general/addMessage', messageData)
			}
			else{
				const messageData = {
					message: 'Error al crear el informe, por favor intenta nuevamente.',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', messageData)
			}
		}
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
	.custom-toggle-btns .v-btn--active:before{
		opacity: 0;
	}
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>